//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance_rule",
    data() {
        return {
            title: "获积分+查真伪，这样玩",
            url: window.location.href //当前地址
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        }
    },
    methods: {
        //获取token
        get_token(url) {
            this.$EpetJs.Common.approve(url,function() {}); //生成token
        }
    }
};
